import { render, staticRenderFns } from "./Cardcomment.vue?vue&type=template&id=296685e8&"
import script from "./Cardcomment.vue?vue&type=script&lang=js&"
export * from "./Cardcomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports